import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCreateTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 15" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M14 5h1v4h-1zm-2-1h5v1h-5z" fill="#007AFF" />
      <g fill="#007AFF">
        <path d="M2.4 4h1v6h-1z" />
        <path d="M6 6.4v1H0v-1z" />
      </g>
      <path
        stroke="#007AFF"
        d="M21.867 1C22.493 1 23 1.474 23 2.06v9.98c0 .774-.672 1.403-1.501 1.403-.33 0-.65-.102-.912-.289l-1.69-1.209a1.195 1.195 0 0 0-1.42.032L15.23 13.75a1.194 1.194 0 0 1-1.46.002l-2.262-1.777a1.195 1.195 0 0 0-1.419-.029l-1.683 1.208c-.655.47-1.593.355-2.096-.258a1.34 1.34 0 0 1-.309-.85V11"
      />
      <path stroke="#007AFF" d="M6 3v-.94C6 1.474 6.507 1 7.133 1H22" />
    </g>
  </svg>
);
const Memo = memo(SvgCreateTicket);
export default Memo;
